/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {addRoundToTab} from '../api'

export const useMutationAddRoundToTab = createReactQueryMutationHook('addRoundToTab', addRoundToTab)
